import can from 'can';
import Component from 'can/component/component';
import template from './modal-dialog.stache';
import appContext from 'scripts/app-context';

const dialogModel = can.Map.extend({
    element: null,
    parent: null,
    define: {
        active: {
            type: 'htmlbool',
            value: false
        },
        customBody: {
            type: 'htmlbool',
            value: false
        },
        renderOnShow: {
            type: 'htmlbool',
            value: false
        },
        title: {
            type: 'string',
            value: ''
        },
        smallFullScreen: {
            type: 'htmlbool',
            value: false
        },
        className: {
            type: 'string',
            value: ''
        }
    },
    show () {
        let $el = this.attr('element');
        let $parent = $el.parent();
        this.attr('parent', $parent);
        if ($el && $el.length) {
            $el.appendTo(document.body);
        }
        this.attr('active', true);
        this.dispatch('modalOpened', []);
        appContext.model.dispatch('page-scroll-toggle', [true]);
    },
    hide () {
        if (!this.attr('active')) {
            return;
        }
        let $el = this.attr('element');
        this.attr('active', false);
        let $parent = this.attr('parent');
        if ($parent && $parent.length) {
            $el.appendTo($parent);
        } else {
            this.attr('element', null);
            can.remove($el);
        }
        this.dispatch('modalClosed', []);
        appContext.model.dispatch('page-scroll-toggle', [false]);
    }
});

Component.extend({
    viewModel: dialogModel,
    template: template,
    leakScope: false,
    tag: 'modal-dialog',
    events: {
        inserted: function ($el) {
            this.viewModel.attr('element', $el);
            this.viewModel.dispatch('modalInserted', []);
        },
        '{document} keyup'(element, event) {
            if (event.keyCode === 27 && this.viewModel.attr('active')) {
                this.viewModel.hide();
            }
        },
        '.s-modal-overlay click'() {
            this.viewModel.hide();
        },
        '.s-btn-close click'() {
            this.viewModel.hide();
        }
    }
});